module.exports = __webpack_public_path__ + "img/copy-to-clipboard.a7ea21c.svg";